import React from 'react';
import moment from 'moment';
import './LineaTiempoAprobacion.css';

const LineaTiempoAprobacion = ({ responsables, historial }) => {
  return (
    <div className="timeline-container">
      <div className="timeline">
        {responsables && responsables.map((resp, index) => {
          let statusClass = 'pending';
          let icon = 'hourglass-split';

          if (resp.estado === 'aprobado') {
            statusClass = 'approved';
            icon = 'check-circle-fill';
          } else if (resp.estado === 'rechazado') {
            statusClass = 'rejected';
            icon = 'x-circle-fill';
          }

          return (
            <div key={index} className={`timeline-item ${statusClass}`}>
              <div className="timeline-marker">
                <i className={`bi bi-${icon}`}></i>
              </div>
              <div className="timeline-content">
                <div className="timeline-header">
                  <h6 className="mb-1">
                    {resp.orden}° Aprobador - {resp.usuario.nombre}
                  </h6>
                  <span className={`badge bg-${
                    resp.estado === 'aprobado' ? 'success' :
                    resp.estado === 'rechazado' ? 'danger' : 'warning'
                  }`}>
                    {resp.estado}
                  </span>
                </div>
                <p className="text-muted mb-1">
                  <i className="bi bi-envelope me-2"></i>
                  {resp.usuario.email}
                </p>
                {resp.fechaAprobacion && (
                  <p className="text-muted mb-1">
                    <i className="bi bi-calendar-check me-2"></i>
                    {moment(resp.fechaAprobacion).format('DD/MM/YYYY HH:mm')}
                  </p>
                )}
                {resp.comentarios && (
                  <div className="alert alert-light mb-0 mt-2">
                    <small>
                      <i className="bi bi-chat-left-quote me-2"></i>
                      {resp.comentarios}
                    </small>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LineaTiempoAprobacion;